import { render, staticRenderFns } from "./R24.vue?vue&type=template&id=7391ac4e"
import script from "./R24.vue?vue&type=script&lang=js"
export * from "./R24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports